import '@ionic/core';
import { Component, Element, h, Prop, State, Watch } from '@stencil/core';

@Component({
    tag: 'language-chips',
    styleUrl: 'language-chips.css',
    shadow: true,
    assetsDirs: ['assets']
  })
  export class LanguageChips {
    @Element() el: HTMLElement;

    @Prop({ attribute: 'card-summary' }) cardSummary: string = "This is a test summary #SpeaksCreole for something important #SpeaksFrench";

    @State() speakerLanguages: string[] = [];

    componentWillRender() {
        this.handleSummaryChange(this.cardSummary);
    }

    @Watch('cardSummary')
    handleSummaryChange(newSummary: string) {
        // Remove any ' and ’ characters from the summary
        newSummary = newSummary.replace(/['’]/g, '');

        // Check for #speaks{langauge} hashtags
        const speaksRegexp = new RegExp('#speaks([A-Za-z]*)','gi');
        const matches = newSummary.toLowerCase().match(speaksRegexp);

        if (matches) {
            this.speakerLanguages = matches.map((match) => {
                // Remove '#speaks' from the start of each match
                return match.replace('#speaks', '');
            });
        }
    }

    render() {
        const speakerLanguageChips = this.speakerLanguages.map((language) => {
            language = (language.charAt(0).toUpperCase() + language.slice(1))

            let icon;

            const languageIcons = {
                'creole': '🇭🇹',
                'french': '🇫🇷',
                'spanish': '🇪🇸',
                'german': '🇩🇪',
                'russian': '🇷🇺',
                'mandarin': '🇨🇳',
                'korean': '🇰🇷',
                'vietnamese': '🇻🇳',
                'qeqchi': '🇧🇿',
                'mam': '🇬🇹',
                'ixil': '🇬🇹',
                'akateco': '🇬🇹',
                'popti': '🇬🇹',
                'chuj': '🇬🇹',
                'kiche': '🇬🇹',
                'qanjobal': '🇬🇹',
                'ukrainian': '🇺🇦',
                'dari': '🇦🇫',
            };
            
            const iconSymbol = languageIcons[language.toLocaleLowerCase()] || '🗣️';
            icon = <div class="lang-chip-icon">{iconSymbol}</div>;

            return <ion-chip outline>{icon}<ion-label>Speaks {language}</ion-label></ion-chip>;
        });

        return (<div>{speakerLanguageChips}</div>);
    }
}
